import { render, staticRenderFns } from "./ComprovantesGrid.vue?vue&type=template&id=02c7a907&"
import script from "./ComprovantesGrid.vue?vue&type=script&lang=ts&"
export * from "./ComprovantesGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports